import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=b533d866&scoped=true&"
import script from "./DashboardCards.vue?vue&type=script&lang=js&"
export * from "./DashboardCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b533d866",
  null
  
)

export default component.exports